import React, { useState } from 'react'
import { Box, Flex, Heading, Text } from 'rebass/styled-components'
import { useTranslation } from 'gatsby-plugin-react-i18next'
import PropTypes from 'prop-types'

import ExpandCard from './ExpandCard'
import ImageAnimations from './ImageAnimations'

const AccordionSection = ({ type, subtype }) => {
  const { t } = useTranslation(type)
  const { cards } = t(subtype, { returnObjects: true })
  const [currentImage, setCurrentImage] = useState(cards[0].image)

  return (
    <Box as="section" maxWidth="container" mx="auto" pt={[20, 25]} px={[5, 5, 0]} pb={[18, 24, 32]}>
      <Flex alignItems="center">
        <Box
          width={0.5}
          maxWidth="655px"
          mr={[0, 0, 30]}
          sx={{
            '@media (max-width: 80rem)': {
              display: 'none'
            }
          }}
        >
          <ImageAnimations
            delay={100}
            type="left"
            imageName={currentImage}
            style={{
              height: '100%'
            }}
          />
        </Box>

        <Flex
          flexDirection="column"
          justifyContent="center"
          mx="auto"
          maxWidth={['auto', '680px', '496px']}
          width={1}
        >
          <Heading
            mb={t(`${subtype}.subtitle`) !== 0 ? [6, 10, 15] : 0}
            variant="level2"
            textAlign={['left', 'center', 'left']}
          >
            {t(`${subtype}.title`)}
          </Heading>

          {t(`${subtype}.subtitle`) !== '' && (
            <Text as="p" mt={8} mx={[0, 'auto', 0]} mb={[10, 10, 15]} variant="level5">
              {t(`${subtype}.subtitle`)}
            </Text>
          )}

          {cards.map((card) => (
            <ExpandCard
              width={1}
              key={card.title}
              mb={5}
              active={currentImage.includes(card.image)}
              title={card.title}
              description={card.description}
              onClick={() => setCurrentImage(card.image)}
              imageName={card.image}
            />
          ))}
        </Flex>
      </Flex>
    </Box>
  )
}

AccordionSection.propTypes = {
  type: PropTypes.string,
  subtype: PropTypes.string
}

export default AccordionSection
